// extracted by mini-css-extract-plugin
module.exports = {"container":"_35875ce240--container--sXhfv","card":"_35875ce240--card--zF8MV","title":"_35875ce240--title--j5pef"};